export default __webpack_public_path__ + "static/media/n1.f5ef2a5a.svg";